import React from 'react';
import { Form, Input, Select, InputNumber, DatePicker, Upload, Button, Icon, Checkbox, Row, Col } from 'antd';

import withSpin from 'components/Portal/FieldAdmin/withSpin';

const dummyRequest = ({ file, onSuccess }) => {
	setTimeout(() => {
		onSuccess("ok");
	}, 0);
};

const formItemLayout = {
	labelCol: {
		xs: { span: 24 },
		sm: { span: 6 },
	},
	wrapperCol: {
		xs: { span: 24 },
		sm: { span: 14 },
	},
	marginBottom: '8pt'
};

const buttonStyle = {
	textAlign: 'right'
};

class AddProgram extends React.Component {
	state = {
		selectedFile: null,
		selectedMainImage: null,
		selectedFileList: []
	}

	handleSubmit = (event) => {
		event.preventDefault();
		this.props.form.validateFields((err, values) => {
			//console.log('Received values of form: ', values);
			//if(!err)
			this.setState({ 'formEntries': values });
		});
		console.log("submitted data: " + JSON.stringify(this.state.formEntries));
		this.props.isSubmitting();
		this.props.addFieldProgram(this.state.formEntries)
			.catch(console.error)
			.then(() => { this.props.isSubmitted(); });
	}
	onChangeMain = info => {
		const nextState = {};
		switch (info.file.status) {
			case "uploading":
				nextState.selectedFileList = [info.file];
				break;
			case "done":
				nextState.selectedFile = info.file;
				nextState.selectedFileList = [info.file];
				break;

			default:
				// error or removed
				nextState.selectedFile = null;
				nextState.selectedFileList = [];
		}
		this.setState(() => nextState);
	};

	onChangeCarousel = info => {
		const nextState = {};
		switch (info.file.status) {
			case "uploading":
				nextState.selectedMainImage = info.file;
				break;
			case "done":
				nextState.selectedFile = info.file;
				nextState.selectedMainImage = info.file;;
				break;

			default:
				// error or removed
				nextState.selectedFile = null;
				nextState.selectedMainImage = null;
		}
		this.setState(() => nextState);
	};
	handleUpload(info) {
		console.log("entered: " + JSON.stringify(info.fileList));
		this.setState({ selectedFileList: info.fileList });
		console.log("files: " + JSON.stringify(this.state.selectedFiles));
	}
	render() {
		const { getFieldDecorator } = this.props.form;
		return (
			<Form onSubmit={this.handleSubmit}>
				<legend>Add New Field Program</legend>
				<Form.Item label="Code" {...formItemLayout}>
					{getFieldDecorator('Code', {
						rules: [{ required: true, message: 'Code is required' }]
					})(
						<Input />
					)}
				</Form.Item>
				<Form.Item label="Cruise Number" {...formItemLayout}>
					{getFieldDecorator('CruiseNumber', {
						rules: [{ required: true, message: 'Cruise number is required' }]
					})(
						<Input />
					)}
				</Form.Item>
				<Form.Item label="Department Code" {...formItemLayout}>
					{getFieldDecorator('DepartmentCode', {
						rules: [{ required: true, message: 'Department code is required' }]
					})(
						<Input />
					)}
				</Form.Item>
				<Form.Item label="Type" {...formItemLayout}>
					{getFieldDecorator('Type', {
						rules: [{ required: true, message: 'Type is required' }]
					})(
						<Select>
							<Option value="M">Morning</Option>
							<Option value="A">Afternoon</Option>
							<Option value="E">Evening</Option>
							<Option value="D">All Day</Option>
							<Option value="I">Midday</Option>
							<Option value="S">Multiple Days</Option>
							<Option value="O">Other</Option>
						</Select>
					)}
				</Form.Item>
				<Form.Item label="Port" {...formItemLayout}>
					{getFieldDecorator('Port', {
						rules: [{ required: true, message: 'Port is required' }]
					})(
						<Input />
					)}
				</Form.Item>
				<Form.Item label="Title" {...formItemLayout}>
					{getFieldDecorator('Title', {
						rules: [{ required: true, message: 'Title is required' }]
					})(
						<Input />
					)}
				</Form.Item>
				<Form.Item label="Summary" {...formItemLayout}>
					{getFieldDecorator('Summary', {
						rules: [{ required: true, message: 'Summary is required' }]
					})(
						<Input />
					)}
				</Form.Item>
				<Form.Item label="Description" {...formItemLayout}>
					{getFieldDecorator('Description', {
						rules: [{ required: true, message: 'Description is required' }]
					})(
						<Input />
					)}
				</Form.Item>
				<Form.Item label="Itinerary" {...formItemLayout}>
					{getFieldDecorator('Itinerary', {
						rules: [{ required: true, message: 'Itinerary is required' }]
					})(
						<Input />
					)}
				</Form.Item>
				<Form.Item label="Inclusions" {...formItemLayout}>
					{getFieldDecorator('Inclusions', {
						rules: [{ required: true, message: 'Inclusions is required' }]
					})(
						<Input />
					)}
				</Form.Item>
				<Form.Item label="Minimum Participants" {...formItemLayout}>
					{getFieldDecorator('MinParticipant', {
						rules: [{ required: true, message: 'Minimum number of participants is required' }]
					})(
						<InputNumber min={0} />
					)}
				</Form.Item>
				<Form.Item label="Maximum Participants" {...formItemLayout}>
					{getFieldDecorator('MaxParticipant', {
						rules: [{ required: true, message: 'Maximim number of participants is required' }]
					})(
						<InputNumber min={0} />
					)}
				</Form.Item>
				<Form.Item label="Minimum Age" {...formItemLayout}>
					{getFieldDecorator('MinAge', {
						rules: [{ required: true, message: 'Minimum age is required' }]
					})(
						<InputNumber min={0} />
					)}
				</Form.Item>
				<Form.Item label="Notes" {...formItemLayout}>
					{getFieldDecorator('Notes', {
						rules: [{ required: true, message: 'Notes is required' }]
					})(
						<Input />
					)}
				</Form.Item>
				<Form.Item label="Price" {...formItemLayout}>
					{getFieldDecorator('Price', {
						rules: [{ required: true, message: 'Price is required' }]
					})(
						<InputNumber formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} parser={value => value.replace(/\s?|(,*)/g, '')} precision={2} />
					)}
				</Form.Item>
				<Form.Item label="Child Price" {...formItemLayout}>
					{getFieldDecorator('ChildPrice', {
						rules: [{ required: true, message: 'Child price is required' }]
					})(
						<InputNumber formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} parser={value => value.replace(/\s?|(,*)/g, '')} precision={2} />
					)}
				</Form.Item>
				<Form.Item label="Departing" {...formItemLayout}>
					{getFieldDecorator('Departing', {
						rules: [{ required: true, message: 'Departing is required' }]
					})(
						<DatePicker />
					)}
				</Form.Item>
				<Form.Item label="Returning" {...formItemLayout}>
					{getFieldDecorator('Returning', {
						rules: [{ required: true, message: 'Returning is required' }]
					})(
						<DatePicker />
					)}
				</Form.Item>
				<Form.Item label="Capacity" {...formItemLayout}>
					{getFieldDecorator('Capacity', {
						rules: [{ required: true, message: 'Capacity is required' }]
					})(
						<InputNumber min={0} />
					)}
				</Form.Item>
				<Form.Item label="IsLeanIn?" {...formItemLayout}>
					{getFieldDecorator('IsLeanIn', {
					})(
						<Checkbox />
					)}
				</Form.Item>
				<Form.Item label="IsStrenuous?" {...formItemLayout}>
					{getFieldDecorator('IsStrenuous', {
					})(
						<Checkbox />
					)}
				</Form.Item>
				<Form.Item label="IsFastPaced?" {...formItemLayout}>
					{getFieldDecorator('IsFastPaced', {
					})(
						<Checkbox />
					)}
				</Form.Item>
				<Form.Item label="Mobility Level" {...formItemLayout}>
					{getFieldDecorator('physical_activity_level', {
						option: { initialValue: 0 },
						rules: [{ required: true, message: 'Mobility Level is required' }]
					})(
						<Select>
							<Option value='0'></Option>
							<Option value='1'>1</Option>
							<Option value='2'>2</Option>
							<Option value='3'>3</Option>
							<Option value='4'>4</Option>
						</Select>
					)}
				</Form.Item>
				<Form.Item label="ButtonNumber" {...formItemLayout}>
					{getFieldDecorator('ButtonNumber', {
						rules: [{ required: true, message: 'Button number is required' }]
					})(
						<InputNumber min={0} />
					)}
				</Form.Item>
				<Form.Item label="ButtonCaption" {...formItemLayout}>
					{getFieldDecorator('ButtonCaption', {
						rules: [{ required: true, message: 'Button caption is required' }]
					})(
						<Input />
					)}
				</Form.Item>
				<Form.Item label="Overbooking" {...formItemLayout}>
					{getFieldDecorator('Overbooking', {
						option: { initialValue: 'N' },
						rules: [{ required: true, message: 'Overbooking is required' }]
					})(
						<Select>
							<Option value='A'>Allowed</Option>
							<Option value='N'>Not Allowed</Option>
						</Select>
					)}
				</Form.Item>
				<Form.Item label="Image" {...formItemLayout}
					extra="Upload main program image">
					{getFieldDecorator('image', {
						valuePropName: 'mainImage',
						rules: [{ required: true, message: 'Main image is required' }]
					})(
						<Upload
							className="avatar-uploader"
							name="avatar"
							accept=".jpg"
							multiple={false}
							showUploadList={false}
							file={this.state.selectedMainImage}
							customRequest={dummyRequest}
							onChange={this.onChangeMain}
						>
							<Icon type="plus" className="avatar-uploader-trigger" />
						</Upload>
					)}
				</Form.Item>
				<Form.Item label="Carousel Image(s)" {...formItemLayout}>
					{getFieldDecorator('dragger', {
						rules: [{ required: true, message: 'At least one carousel image is required' }]
					})(
						<div>
							<Row>
								<Col span={7}>
									<div className="dropbox">
										<Upload.Dragger name="files" accept=".jpg" multiple={true} fileList={this.state.selectedFileList} customRequest={dummyRequest} onChange={this.onChangeCarousel}>
											<p className="ant-upload-drag-icon">
												<Icon type="inbox" />
											</p>
											<p className="ant-upload-text">Click or drag carousel image(s) to this area to upload</p>
											<p className="ant-upload-hint">Support for a single or bulk upload.</p>
										</Upload.Dragger>
									</div>
								</Col>
							</Row>
						</div>
					)}
				</Form.Item>
				<Form.Item {...formItemLayout} style={buttonStyle}>
					<Button
						type="primary"
						htmlType="submit"
						icon="save"
						disabled={!this.props.form.isFieldsTouched()}
						loading={this.props.getStatus().submitting}>
						{this.props.buttonText || 'Save'}
					</Button>
				</Form.Item>
			</Form>
		);
	}
}

export default withSpin(Form.create()(AddProgram));


// WEBPACK FOOTER //
// ./portal-components/Portal/FieldAdmin/AddProgram/index.jsx